import SspList from 'common/pages/ssp/SspList.tsx'

export const SspListAgency = (props: any) => <SspList {...props} mode={props.mode} />